import React, {useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {setBetting} from 'virtual_congress/exhibition_actions'
import axios from 'axios';
import RenderedHtmlContent from "src/shared/virtual_congress/components/rendered_html_content";
import classNames from 'classnames'


export default function VotingForm({bet, betting, event, questionDisabled, locale, ...props}) {
  const tagOwner = useSelector((state) => state.tagOwner)
  const bettingsUrl = useSelector((state) => state.bettingsUrl).replace("@tag_owner_id@", tagOwner.id)
  const [sending, setSending] = useState(false)
  const [showThankYou, setShowThankYou] = useState(false)
  const dispatch = useDispatch()
  const [selectedValue, setSelectedValue] = useState(null)
  const [canVote, setCanVote] = useState(true)
  const hasVoted = !!betting
  const disabled = sending || hasVoted || bet.show_results || !canVote || questionDisabled

  const sendForm = (selectedValue) => {
    setSelectedValue(selectedValue)
    if (sending) {
      return
    }

    setSending(true)
    const data = {
      bet_id: bet.id,
      bet_option_id: selectedValue,
      betting: {
        bet_option_id: selectedValue,
        bet_option_1_value: 0,
        bet_option_2_value: 0,
        bet_option_3_value: 0,
        bet_option_4_value: 0,
      }
    }

    data.betting[`bet_option_${selectedValue}_value`] = 1

    //replace("@video_room_id@", props.videoRoom.id).
    axios.put(bettingsUrl.replace("@id@", bet.id), data).then(response => {
        console.log("response", response.data)
        if (response.data.status == "OK") {
          console.log(response.data.questions)
          dispatch(setBetting(response.data.betting))
          setShowThankYou(true)
          setTimeout(function () {
            setShowThankYou(false)
          }, 3000);
        } else {

        }
      },
      error => {
        alert(error)
        console.error(error)
        setSending(false)
      })
  }
  return (
    <>
      <RenderedHtmlContent identifier="video_room.custom_voting_html"/>
      {showThankYou && false ? (
        <div className="alert alert-success m-3">
          Thank you!
        </div>
      ) : (
        <>
          <div className={classNames("container-fluid bet-container", {"has-voted": hasVoted})}>
            <div className="row">
              {[1, 2, 3, 4].map(optionNumber => {
                return <div className="col-12 col-md-6" key={optionNumber}>
                  <div
                    className={classNames("bet-answer", {
                      disabled: disabled,
                      selected: optionNumber == betting?.bet_option_id || optionNumber == selectedValue,
                      correct: bet.show_results && bet[`bet_option_${optionNumber}_correct`],
                      incorrect: bet.show_results && betting?.bet_option_id == optionNumber && !bet[`bet_option_${optionNumber}_correct`],
                    })}
                    onClick={() => !disabled && sendForm(optionNumber)}>
                    {bet["bet_option_"+ optionNumber + "_label"]}
                  </div>
                </div>
              })}
            </div>
          </div>
        </>
      )}
    </>
  )
}


